export const queryKeys = {
  app: {
    all: (locale: string) => ['app', locale] as const,
  },
  authFlow: {
    pendingSignupFirstName: () =>
      ['auth-flow', 'pending-signup-first-name'] as const,
    createUserAttempt: (userId: string | null) =>
      ['auth-flow', 'create-user-attempt', userId] as const,
  },
  purchase: {
    offerings: (revenueCatUserId: string | null, targetCurrency: string) =>
      ['purchase', 'offerings', revenueCatUserId, targetCurrency] as const,
  },
  dashboard: {
    all: (locale: string) => ['dashboard', locale] as const,
    byWeek: (locale: string, week: number) =>
      ['dashboard', locale, 'week', week] as const,
    stable: (locale: string, activeWeek: number) =>
      ['dashboard', locale, 'stable', activeWeek] as const,
    weeklyExercises: (
      locale: string,
      viewedWeek: number,
      currentWeek: number,
    ) =>
      [
        'dashboard',
        locale,
        'weekly-exercises',
        viewedWeek,
        currentWeek,
      ] as const,
    subjects: {
      byLocale: (locale: string) => ['dashboard', locale, 'subjects'] as const,
    },
    weeks: {
      byLocale: (locale: string) => ['dashboard', locale, 'weeks'] as const,
    },
    tips: {
      byLocale: (locale: string) => ['dashboard', locale, 'tips'] as const,
    },
    morningRoutine: {
      byLocale: (locale: string) =>
        ['dashboard', locale, 'morning-routine'] as const,
    },
  },
  backendSessions: {
    all: () => ['backend-sessions'] as const,
    byId: (id: number) => ['backend-session', id] as const,
    definition: (id: number, languageCode: string) =>
      ['backend-session-definition', id, languageCode] as const,
  },
  sessions: {
    all: (locale: string) => ['sessions', locale] as const,
    byLocale: (id: string, locale: string) => ['sessions', locale, id] as const,
  },
  library: {
    all: (locale: string) => ['library', locale] as const,
  },
  progress: {
    all: ['progress'] as const,
    session: (id: string) => ['progress', id] as const,
    activeWeek: () => ['progress', 'activeWeek'] as const,
    snapshotAll: () => ['progress', 'snapshot'] as const,
    snapshot: (yearWeek: string) => ['progress', 'snapshot', yearWeek] as const,
  },
  exercise: {
    goalAll: () => ['exercise', 'goal'] as const,
    goalCurrent: () => ['exercise', 'goal', 'current'] as const,
    goal: (yearWeek: string) => ['exercise', 'goal', yearWeek] as const,
    week: (yearWeek: string) => ['exercise', 'week', yearWeek] as const,
    dashboardInfoAll: () => ['exercise', 'dashboard-info'] as const,
    dashboardInfo: (yearWeek: string) =>
      ['exercise', 'dashboard-info', yearWeek] as const,
  },
  activities: {
    stats: () => ['activities', 'stats'] as const,
  },
  favorites: {
    all: ['favorites'] as const,
  },
  measurements: {
    all: () => ['measurements'] as const,
    byId: (measurementId: number) => ['measurements', measurementId] as const,
  },
  warmup: {
    weekdayCompletion: (yearWeek: string) =>
      ['warmup', 'weekday-completion', yearWeek] as const,
  },
  user: {
    profile: (userId: string | null) =>
      ['user', 'profile', 'v2', userId] as const,
    profileSync: (userId: string | null) =>
      ['user', 'profile', 'sync', userId] as const,
    profileWithRevenueCatId: (userId: string | null) =>
      ['user', 'profile', 'revenuecat-id', userId] as const,
    customerInfo: (userId: string | null) =>
      ['user', 'customer-info', userId] as const,
    deletionEligibility: (userId: string | null) =>
      ['user', 'deletion-eligibility', userId] as const,
    credentials: (userId: string | null) =>
      ['user', 'credentials', userId] as const,
    emailVerification: {
      all: () => ['user', 'email-verification'] as const,
      byUserId: (userId: string | null) =>
        ['user', 'email-verification', userId] as const,
    },
  },
  mutations: {
    createUser: ['mutation', 'create-user'] as const,
    onboardingSignIn: ['mutation', 'onboarding', 'sign-in'] as const,
    onboardingStartTrial: ['mutation', 'onboarding', 'start-trial'] as const,
    completePostPaymentOnboarding: [
      'mutation',
      'complete-post-payment-onboarding',
    ] as const,
    sessionCompletion: ['mutation', 'session-completion'] as const,
    sessionStarted: ['mutation', 'session-started'] as const,
    sessionAborted: ['mutation', 'session-aborted'] as const,
    sessionEnded: ['mutation', 'session-ended'] as const,
    saveProgress: ['mutation', 'save-progress'] as const,
    activeWeek: ['mutation', 'active-week'] as const,
    measurementCreated: ['mutation', 'measurement-created'] as const,
    measurementRecordingSaved: [
      'mutation',
      'measurement-recording-saved',
    ] as const,
    updateUser: ['mutation', 'update-user'] as const,
  },
} as const
